import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Unit_Interface, Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';

@Component({
  selector: 'app-UnitList',
  templateUrl: './UnitList.component.html',
  styleUrls: ['./UnitList.component.css']
})
export class UnitListComponent implements OnInit {

  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Unit_Service:UnitService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Unit:Array<Unit_Interface>=[]
  Data_Seleted_Delete:Unit_Interface=Empty_Unit_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(48).subscribe(
      data=>{
        this.ReadData_Unit()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Unit(){
    this.Procssing=true
    this.Unit_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Unit=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:Unit_Interface){
    this.modalRef_Delete.hide()
    this.Unit_Service.DeleteUnit(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Unit()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
